/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Label1Inputs */

const ja_company_companydetails_label1 = /** @type {(inputs: Company_Companydetails_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社概要`)
};

const en_company_companydetails_label1 = /** @type {(inputs: Company_Companydetails_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Details`)
};

/**
* | output |
* | --- |
* | "Company Details" |
*
* @param {Company_Companydetails_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_label1 = /** @type {((inputs?: Company_Companydetails_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_label1(inputs)
	return en_company_companydetails_label1(inputs)
});
export { company_companydetails_label1 as "company_companyDetails_label" }